<template>
  <div class="p-12">
    <div class="flex justify-between">
      <h4 class="text-indigo-500 capitalize">Pages</h4>
      <PagesSync @synced="refreshData" />
    </div>
    <div class="grid grid-cols-3 gap-12 mt-16">
      <PageCard v-for="page in pages" :key="page.id" :page="page" @change="handleChange" />
    </div>

    <div v-if="hasMore" class="mt-12 text-center">
      <button
        v-if="!rejected"
        class="border border-gray-400 bg-white text-gray-900 px-4 py-2"
        @click="loadMore"
      >
        <Loader v-if="loading" small />
        Load more ...
      </button>

      <template v-else>
        <div class="rounded-md bg-red-50 p-4 sm: max-w-sm w-full mx-auto">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-red-400"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0
                  00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10
                  11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1
                  1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
            <div class="ml-3">
              <h3 class="text-sm font-medium text-red-800">Something went wrong</h3>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import PagesSync from './index/pages-sync.vue';
import PageCard from './index/PageCard.vue';
import { FACEBOOK_PAGES } from '@/store/entities/schema_types';

export default {
  components: {
    PagesSync,
    PageCard,
  },
  data() {
    return {
      loading: false,
      rejected: false,
      all: [],
    };
  },
  computed: {
    pages() {
      return this.all.map((id) => this.$store.state.entities.facebookPages.byId[id]);
    },
    meta() {
      return this.$store.state.admin.facebookPages.meta;
    },
    hasMore() {
      const { current_page: current = 0, last_page: last = 0 } = this.meta || {};

      return current < last;
    },
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.$store.commit('admin/facebookPages/setLinks', null);
    this.$store.commit('admin/facebookPages/setMeta', null);
    this.$store.commit('admin/facebookPages/setIds', []);
  },
  methods: {
    handleChange(page) {
      this.$store.dispatch('entities/persistEntities', { type: FACEBOOK_PAGES, data: page });
    },
    async fetchData(query = {}) {
      if (this.loading) return;

      this.loading = true;

      try {
        const { ids } = await this.$store.dispatch('admin/facebookPages/load', {
          ...query,
          include: 'accounts_count',
        });
        this.all = [...new Set([...this.all, ...ids])];
      } catch (error) {
        this.rejected = true;
      } finally {
        this.loading = false;
      }
    },
    loadMore() {
      if (!this.hasMore) {
        return;
      }

      this.fetchData({
        page: this.meta.current_page + 1,
      });
    },
    refreshData() {
      this.all = [];

      this.fetchData();
    },
  },
};
</script>
